import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Container,
    Divider,
    Form,
    Grid,
    Menu,
    Segment,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import AppForm from '../../components/AppForm';
import NavBar from '../../components/NavBar';
import ManageSettingsModal from './ManageSettingsModal';

class ManageSettings extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        shortName: PropTypes.string,
      }),
      isDeveloper: PropTypes.bool,
    }),
  }
  static getPropsToState = (props) => {
    const loading = false;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = ManageSettings.getPropsToState(props);
    this.state = {
      ...state,
      companyAppCredit: [],
      companyApp: [],
      errMessages: [],
      hasChanges: false,
      hasHQApprovalChanges: false,
      loading: false,
      openModal: false,
      token: '',
    };
  }
  componentDidMount() {
    this.fetchCompanyApp();
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  handleCheckBoxChange = (event, data) => {
    const { name } = data;
    const { companyApp } = this.state;
    let { hasHQApprovalChanges } = this.state;
    companyApp[name] = !companyApp[name];
    if (name === 'requiredHQApproval') {
      hasHQApprovalChanges = true;
    }
    this.setState({ companyApp, hasChanges: true, hasHQApprovalChanges });
  }
  handleSave = async () => {
    const { store } = this.context;
    try {
      await store.dispatch(fetchM('/company/company_app/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(this.state.companyApp),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setLoading(false);
    this.setState({ openModal: false, hasHQApprovalChanges: false });
    store.dispatch(flashSuccessMessage({ header: 'Update success', message: 'Credit Check Settings is updated' }));
  }
  handleShowModal = () => {
    this.setState({ openModal: true });
  }
  async fetchCompanyApp() {
    const { store } = this.context;
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM('/company/company_app/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const companyApp = await res.json();
      const token = res.headers.get('X-Csrf-Token');
      if (companyApp !== null) {
        this.setComponentState({ companyApp, token });
      }
    }
    await this.setLoading(false);
  }
  render() {
    const { companyApp, hasChanges, hasHQApprovalChanges, loading } = this.state;
    return (
      <div>
        {
          companyApp ?
            <AppForm
              onSubmit={hasHQApprovalChanges ? this.handleShowModal : this.handleSave}
              error={this.state.errMessages.length > 0}
            >
              <Container>
                <NavBar
                  header="Credit Check Settings"
                  rightNav={
                    <Menu.Item fitted>
                      <Button
                        primary
                        content="Save"
                        disabled={loading || !hasChanges}
                        onClick={hasHQApprovalChanges ? this.handleShowModal : this.handleSave}
                      />
                    </Menu.Item>
                  }
                />
                <Divider
                  horizontal
                >
                  Credit Check Settings
                </Divider>
                <Segment>
                  <Form.Checkbox
                    label="All Credit Check by internal staff must be approved by HQ before score generated"
                    name="requiredHQApproval"
                    checked={companyApp.requiredHQApproval ? companyApp.requiredHQApproval : false}
                    onChange={this.handleCheckBoxChange}
                  />
                  <Form.Checkbox
                    label="All BU leaders (Supervisor, Sales Manager, and Sales Admin) to download Credit Check detailed report"
                    name="allowBranchLeaderDownload"
                    checked={companyApp.allowBranchLeaderDownload ? companyApp.allowBranchLeaderDownload : false}
                    onChange={this.handleCheckBoxChange}
                  />
                  <Form.Checkbox
                    label="All Agents to download Credit Check detailed report"
                    name="allowAgentDownload"
                    checked={companyApp.allowAgentDownload ? companyApp.allowAgentDownload : false}
                    onChange={this.handleCheckBoxChange}
                  />
                  <Form.Checkbox
                    label="All Staff to download Credit Check detailed report"
                    name="allowStaffDownload"
                    checked={companyApp.allowStaffDownload ? companyApp.allowStaffDownload : false}
                    onChange={this.handleCheckBoxChange}
                  />
                </Segment>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <ManageSettingsModal
                        open={this.state.openModal}
                        onSave={this.handleSave}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </AppForm> : null
        }
      </div>
    );
  }
}

export default connect(ManageSettings.mapStateToProps)(ManageSettings);



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/ManageSettings.jsx